import React from 'react';
import PropTypes from 'prop-types';

import { QueryEntity, QueryGroup } from '../';

const QueryItem = ({
  item,
  index,
  parentGroupId,
  entitiesInfos,
  conversationQueries = {},
  isOuter,
  entityDragging,
  onAddEntityRequest,
  onUpdateEntityRequest,
  onDeleteEntityRequest,
  onChangeGroupOperatorRequest,
  onEntityDragToggle,
  onItemDrop,
  onItemDragStart,
  onRequireMissingItemRequest,
  queryBuilderType,
  color,
  onSelectGroupRequest,
  onChangeGroupAtLeastNumberRequest,
  onAddEntitiesListRequest,
  canDeleteRow = true,
}) => {
  if (item.type === 'block') {
    return (
      <QueryGroup
        group={item}
        index={index}
        parentGroupId={parentGroupId}
        entitiesInfos={entitiesInfos}
        conversationQueries={conversationQueries}
        isOuter={isOuter}
        entityDragging={entityDragging}
        onAddEntityRequest={onAddEntityRequest}
        onUpdateEntityRequest={onUpdateEntityRequest}
        onDeleteEntityRequest={onDeleteEntityRequest}
        onChangeGroupOperatorRequest={onChangeGroupOperatorRequest}
        onEntityDragToggle={onEntityDragToggle}
        onItemDrop={onItemDrop}
        onItemDragStart={onItemDragStart}
        onRequireMissingItemRequest={onRequireMissingItemRequest}
        queryBuilderType={queryBuilderType}
        color={color}
        onSelectGroupRequest={onSelectGroupRequest}
        onChangeGroupAtLeastNumberRequest={onChangeGroupAtLeastNumberRequest}
        onAddEntitiesListRequest={onAddEntitiesListRequest}
      />
    );
  }
  return (
    <QueryEntity
      queryEntity={item}
      index={index}
      parentGroupId={parentGroupId}
      entityInfos={entitiesInfos[`${item.type}_${item.id}`]}
      conversationQuery={conversationQueries[`${parentGroupId}_${item.id}`]}
      onUpdateEntityRequest={onUpdateEntityRequest}
      onDeleteEntityRequest={onDeleteEntityRequest}
      onEntityDragToggle={onEntityDragToggle}
      onItemDragStart={onItemDragStart}
      onRequireMissingItemRequest={onRequireMissingItemRequest}
      queryBuilderType={queryBuilderType}
      canDeleteRow={canDeleteRow}
    />
  );
};

QueryItem.propsType = {
  queryEntity: PropTypes.object,
  index: PropTypes.number,
  parentGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityInfos: PropTypes.object,
  conversationQueries: PropTypes.object,
  onAddEntityRequest: PropTypes.func,
  onUpdateEntityRequest: PropTypes.func,
  onDeleteEntityRequest: PropTypes.func,
  onEntityDragToggle: PropTypes.func,
  onItemDragStart: PropTypes.func,
  queryBuilderType: PropTypes.string,
  color: PropTypes.string,
};

QueryItem.defaultProps = {
  parentGroupId: 0,
  color: null,
};

export default QueryItem;
